// aiuto/ProvaDaSolo.tsx — «Prova da solo» contro il bot (v015), dalla v019 dentro «Come si gioca»: il robottino, due righe e
// il pulsante. Anche senza account; non conta per quota, pubblicità, crediti e statistiche.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../componenti/Avatar.tsx";
import { useAccount, voltoAccettato } from "../servizi/account.ts";
import { ConsensoVolto } from "../gioco/ConsensoVolto.tsx";
import { AvvisoSospensione } from "../componenti/AvvisoSospensione.tsx";
import { creaProvaDaSolo } from "../servizi/prova.ts";
import { salvaToken } from "../servizi/sfide.ts";
import { leggiPreferenza } from "../servizi/preferenze.ts";
import { vai } from "../servizi/percorso.ts";
import { PERCORSO_SFIDA, PREFERENZE } from "../costanti.ts";

export function ProvaDaSolo() {
  const { t } = useTranslation();
  const account = useAccount();
  const [invio, setInvio] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  // v021: prima della prima partita la spiegazione del volto (prima di usare una delle prove del giorno)
  const [volto, setVolto] = useState(false);
  const avvia = () => {
    if (!voltoAccettato()) {
      setVolto(true);
      return;
    }
    setInvio(true);
    setErrore(null);
    const nome = (account.tipo === "registrato" ? account.io.nome : leggiPreferenza(PREFERENZE.nome)) || t("prova.da_solo_nome");
    creaProvaDaSolo(nome)
      .then((r) => {
        salvaToken(r.codice, r.token);
        vai(`${PERCORSO_SFIDA}${r.codice}`);
      })
      .catch((e: { codice?: string }) => {
        setInvio(false);
        setErrore(e?.codice === "troppe_sfide" ? t("prova.da_solo_troppe") : e?.codice === "bloccato" ? "bloccato" : t("prova.da_solo_errore"));
      });
  };
  if (volto)
    return (
      <ConsensoVolto
        onAccettato={() => {
          setVolto(false);
          avvia();
        }}
        onEsci={() => setVolto(false)}
      />
    );
  return (
    <section className="ld-prova">
      <div className="ld-prova-carta">
        <Avatar quale="bot" dimensione={84} classe="ld-prova-bot" />
        <div>
          <h2 className="ld-prova-titolo">{t("prova.da_solo")}</h2>
          <p className="ld-prova-testo">{t("prova.da_solo_invito")}</p>
        </div>
      </div>
      <button type="button" className="ld-cta ld-cta-centrata pulsante-prova-da-solo" disabled={invio} onClick={avvia}>
        {t("prova.da_solo_gioca")}
      </button>
      {errore === "bloccato" ? (
        <AvvisoSospensione seNo={<p className="nota-centrata" role="alert">{t("prova.da_solo_errore")}</p>} />
      ) : errore && (
        <p className="nota-centrata" role="alert">
          {errore}
        </p>
      )}
    </section>
  );
}
